import { Col, Input, Label, Row } from "reactstrap"
import ComponentBackButton from "../../../../common/AdminCommonComponents/Buttons/ComponentBackButton/ComponentBackButton"
import DetailsCard from "../../../../common/AdminCommonComponents/DetailsCard/DetailsCard"
import GrayHeading from "../../../../common/AdminCommonComponents/GrayHeading/GrayHeading"
import styles from "./PayoutDetails.module.scss"

const PayoutDetails = ({ onClick }) => {
  return (
    <div className="bg-white p-3 mt-3 shadow">
      <ComponentBackButton onClick={() => onClick((prev) => !prev)} />
      <div className="d-flex justify-content-center mb-3">
        <GrayHeading>Payout Detail</GrayHeading>
      </div>

      <Row className="row-cols-1 row-cols-md-2 row-cols-lg-3">
        <Col className="d-grid">
          <DetailsCard title="Payout Information" titleColor>
            <Row className="g-0 mt-3 fw-medium">
              <Col>Payout ID:</Col>
              <Col>P001</Col>
            </Row>
            <Row className="g-0 fw-medium mt-1">
              <Col>Date:</Col>
              <Col>2024-11-20</Col>
            </Row>
            <Row className="g-0 border border-secondary p-1 rounded fw-medium mt-1">
              <Col xs='6'>Recipient Type:</Col>
              <Col xs='6'>Seller</Col>
              <Col xs='6'>Recipient Name:</Col>
              <Col xs='6'>John Doe</Col>
            </Row>
            <Row className="g-0 fw-medium mt-1">
              <Col>Amount:</Col>
              <Col className={`${styles['green-bg']} rounded p-1`}>$100.00</Col>
            </Row>
            <Row className="g-0 fw-medium mt-1">
              <Col>Status:</Col>
              <Col className={`${styles['bg-yellow']} rounded p-1`}>Processed</Col>
            </Row>
            <Row className={`g-0 fw-medium mt-1`}>
              <Col xs="6" className={styles["text-light-blue"]}>Payment Method:</Col>
              <Col xs="6">Bank Tranfer</Col>
            </Row>
            <Row className="g-0 mt-1">
              <Col xs="6">Reference Number:</Col>
              <Col xs="6">12345678</Col>
            </Row>
          </DetailsCard>
        </Col>
        <Col className="d-grid">
          <DetailsCard title="Recipient Details" titleColor>
            <div className="mt-3" />
            <Row className="g-0 fw-medium mt-1">
              <Col>Name:</Col>
              <Col>John Doe</Col>
            </Row>
            <Row className="g-0 fw-medium mt-1">
              <Col>Email:</Col>
              <Col className={`${styles["text-blue"]}`}>john.doe@example.com</Col>
            </Row>
            <Row className="g-0 fw-medium mt-1">
              <Col>Contact Number:</Col>
              <Col>1234567890</Col>
            </Row>
            <Row className="g-0 fw-medium mt-1">
              <Col>Bank Account Details:</Col>
            </Row>
            <Row className="g-0 fw-medium mt-1">
              <Col>Account no:</Col>
              <Col>34234234</Col>
            </Row>
          </DetailsCard>
        </Col>
        <Col className="d-grid">
          <DetailsCard title="Actions" titleColor>
            <div className="mt-3" />
            <div>View Transaction History:</div>
            <div className={styles["text-orange"]}>Issue Payout</div>
            <Label htmlFor="addNote">Add Note:</Label>
            <Input type="text" id="addNote" name="addNote" />
            <div className={styles["text-orange"]}>Flag For Review:</div>
            
          </DetailsCard>
        </Col>
      </Row>
    </div>
  )
}

export default PayoutDetails
